var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollectBlank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5207\u7247") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84D6B1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97E3C5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84D6B1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97E3C5",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9b\\u5907\\u4EFD-2",
    transform: "translate(-580.000000, -280.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u6807/\\u7F3A\\u7701\\u9875/\\u8F6F\\u4EF6",
    transform: "translate(580.000000, 280.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(7.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5 L64,5 L64,52 L2,52 C0.8954305,52 1.3527075e-16,51.1045695 0,50 L0,5 L0,5 Z",
    id: "\\u77E9\\u5F62",
    fill: "#D6F5E7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "url(#linearGradient-1)",
    opacity: 0.5,
    x: 6,
    y: 16,
    width: 13,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-3",
    fill: "url(#linearGradient-2)",
    opacity: 0.5,
    x: 24,
    y: 16,
    width: 31,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,0 L64,0 C65.1045695,-2.02906125e-16 66,0.8954305 66,2 L66,50 C66,51.1045695 65.1045695,52 64,52 L62,52 L62,52 L62,0 Z",
    id: "\\u77E9\\u5F62",
    fill: "#AEDCC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,0 L64,0 C65.1045695,-2.02906125e-16 66,0.8954305 66,2 L66,10 L66,10 L62,10 L62,0 Z",
    id: "\\u77E9\\u5F62\\u5907\\u4EFD",
    fill: "#8AC4AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,0 L62,0 L62,0 L62,10 L0,10 L0,2 C-1.3527075e-16,0.8954305 0.8954305,-2.41183085e-16 2,0 Z",
    id: "\\u77E9\\u5F62",
    fill: "#76D4A9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#FFFFFF",
    cx: 44,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62\\u5907\\u4EFD-2",
    fill: "#FFFFFF",
    cx: 50,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62\\u5907\\u4EFD-3",
    fill: "#FFFFFF",
    cx: 56,
    cy: 5,
    r: 2
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectBlank);
export default __webpack_public_path__ + "static/media/collect_blank.6c83c44a991754d94913c0890d9ecedb.svg";
export { ForwardRef as ReactComponent };